import { Interval } from 'luxon';

import merchantGatewayApi from 'apis/merchant-gateway/api';
import { EntityType } from 'common/types';

import { BasketSizeInsight } from './types';
import { getBaseUrl, getBaseUrlV2, getDateRangeForApiCall } from '../utils';

export const getBasketSizeInsightForEntity = (entityType: EntityType, entityId: string, interval: Interval) => {
  // V2 for avg-basket-size is only available for venues
  const baseUrl = entityType === 'venue' ? getBaseUrlV2(entityType, entityId) : getBaseUrl(entityType, entityId);
  return merchantGatewayApi
    .get<BasketSizeInsight>(`${baseUrl}/avg-basket-size`, {
      params: getDateRangeForApiCall(interval),
    })
    .then(response => response.data);
};
